import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";
import MembershipSlider from "./MembershipSlider";

function Hero() {
  const CustomNextArrow = ({ onClick }) => {
    return (
      <div className="custom-next" onClick={onClick}>
        <MdOutlineKeyboardArrowRight size={40} color="black" />{" "}
        {/* Custom icon */}
      </div>
    );
  };

  const CustomPrevArrow = ({ onClick }) => {
    return (
      <div className="custom-prev" onClick={onClick}>
        <MdOutlineKeyboardArrowLeft size={40} color="black" />{" "}
        {/* Custom icon */}
      </div>
    );
  };

  const settings = {
    dots: false,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: false,
    draggable: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    dotsClass: "slick-dots custom-dots hidden",
  };

  const slides = ["Become a member", "Become a member2", "Become a member3"];

  return (
    <div className="hero-container overflow-hidden 2xl:h-[100vh] w-[100vw] xl:h-[100vh] lg:h-[100%] l:h-[100vh] x:h-[100vh] ">
      <MembershipSlider />
      <Slider {...settings}>
        <div className="banner1  overflow-hidden h-[100vh] w-[100vw] relative flex">
          <h1 className="heading absolute sm:top-[45%] sm:left-[60%] md:top-[40%] md:left-[60%] x:top-[40%] x:left-[60%] lg:top-[35%] lg:left-[60%] l:top-[40%] xl:top-[50%] xl:left-[60%] 2xl:top-[50%] 2xl:left-[65%] z-40 text-left sm:text-[20px] md:text-[30px] x:text-[30px] lg:text-[40px] xl:text-[40px] 2xl:text-[60px] lg:leading-[55px] xl:leading-[65px] 2xl:leading-[75px] font-semibold">
            Revolutionizing <br />
            Healthcare With
            <br /> Telemedicine
          </h1>
          <p className="subHeading absolute text-gray-500 font-medium sm:top-[55%] sm:left-[50%] md:top-[60%] md:left-[60%] x:left-[70%] lg:top-[63%] lg:left-[70%] l:top-[62%] l:left-[70%] xl:top-[75%] xl:left-[70%] x:top-[70%]  2xl:top-[73%] 2xl:left-[67%] sm:text-[14px] x:text-[15px] xl:text-[15px] 2xl:text-[20px] md:text-[12px] mt-8">
            Experience the future of healthcare with virtual consultations.
            Connect with top doctors from the comfort of your home.
          </p>
        </div>
        <div className="relative banner2 overflow-hidden h-[100vh] w-[100vw]">
          {/* <img src={banner2} alt="Slide 2" className="hero-image" /> */}
          <h1 className="heading2 absolute lg:leading-[40px] xl:leading-[50px] 2xl:leading-[65px] sm:top-[50%] sm:left-[40%] md:top-[50%] md:left-[33%] x:top-[50%] x:left-[25%] lg:top-[50%]  lg:left-[30%] xl:top-[50%] xl:left-[25%] 2xl:top-[50%] 2xl:left-[30%] z-40 text-left sm:text-[20px] md:text-[30px] x:text-[40px] lg:text-[40px] xl:text-[40px] 2xl:text-[60px] font-semibold">
            Monitor Your Health
            <br /> Digitally
          </h1>
          <p className="subHeading2 absolute sm:top-[65%] sm:left-[45%] md:top-[63%] md:left-[40.5%] x:top-[63%] x:left-[28%] lg:top-[62%] lg:left-[33.5%] xl:top-[59%] xl:left-[27.8%] 2xl:top-[63%] 2xl:left-[30%] sm:text-[14px] md:text-[14px] xl:text-[16px] 2xl:text-[20px] font-normal mt-5">
            Track your vitals seemlessly with our advanced digital tools.
            <br /> Stay informed and proactive about your health.
          </p>
        </div>
      </Slider>
    </div>
  );
}

export default Hero;
